import axios from "../../../util/axios";
// 通用接口，有数据权限限制
export default {
    /** 查询商品品牌 */
    queryBradeList: () => axios.get({url: "/basedata/common/data/queryBradeList"}),
    /** 查询商品分类 */
    queryProductCategoryTree: () => axios.get({url: "/basedata/common/data/queryProductCategoryTree"}),

    /** 查询商品列表，有权限限制,用于供应链下单，包含价格方案功能 */
    querySkuList4Merchant: (merchantId, clientId, searchInfo) => axios.get({url: `/basedata/common/data/querySkuList4Merchant?merchantId=${merchantId}&clientId=${clientId}`, data: searchInfo}),
    /** 查询商品分类, 有权限限制 */
    queryCustomerList: (data) => axios.get({url: "/basedata/common/data/queryCustomerList", data: data}),


    /** 查询商品列表，有权限限制 */
    queryProductList: (data) => axios.post({url: "/basedata/common/data/product/queryProductList", data: data}),
    /** 查询主商品列表（level=1，不包含 SKU），用于小程序跳转商品详情 */
    queryMainProductList: (data) => axios.post({url: "/basedata/common/data/product/queryMainProductList", data: data}),
    /** 查询商品列表，有权限限制,用于供应链下单，包含价格方案功能 */
    queryProductListByPartner: (data) => axios.post({url: "/basedata/common/data/product/queryProductListByPartner", data: data}),
    /**根据多个id查询商品信息*/
    queryProductBaseInfo: (data) => axios.post({url: "/basedata/common/data/product/queryProductBaseInfo", data }),

    /** 查询全部的仓库，有权限限制 */
    queryAllWarehouse: () => axios.get({url: "/basedata/common/data/warehouse/queryAll"}),
    /**按id查询仓库信息*/
    queryWarehouseByIds: (data) => axios.post({url: "/basedata/common/data/warehouse/queryWarehouseByIds", data}),

    /**按id查询仓库信息*/
    queryPartnerList: (data) => axios.post({url: "/basedata/common/data/partner/queryPartnerList", data}),
    /**按id查询仓库信息*/
    queryPartnerBaseInfoByIds: (data) => axios.post({url: "/basedata/common/data/partner/queryPartnerBaseInfoByIds", data}),

    /** 分页商机列表，有数据权限限制，用于「挑一个商机」的下拉（与商机列表页同一套口径） */
    queryOpportunityList: (data) => axios.post({url: "/basedata/common/data/partner/queryOpportunityList", data}),


}

